import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Button } from 'components/shared/Button/Button'
import { Trait } from './common/Trait/Trait'

import styles from './Traits.module.scss'

export const Traits = ({
  attributes,
  label,
  language,
  scores,
  traits,
  traitsCount,
  handleToggle,
  handleToggleAll,
  isAllOpened,
  wrap,
}) => (
  <Box className={styles.traits} direction="column">
    <Box align="center" className={styles.header} justify="space-between">
      <h4
        className={styles.title}
      >{t`${label} has ${traitsCount} sub facets:`}</h4>
      <Button
        label={isAllOpened ? t`Hide all` : t`Show all`}
        size="small"
        variant="text"
        onClick={handleToggleAll}
      />
    </Box>
    <Box shouldWrapContent>
      {R.map(
        trait => (
          <Trait
            key={trait}
            isInitiallyOpen={attributes[trait]}
            onToggle={handleToggle}
            {...{ language, scores, trait, wrap }}
          />
        ),
        traits,
      )}
    </Box>
  </Box>
)
